<div class="flex flex-col items-center mx-4">
  <img [src]="'assets/logo/' + theme() + '/logo.svg'" class="h-10 md:h-20 my-10" draggable="false" alt="Logo TOTEiM" />

  <div class="bg-midground shadow rounded w-full md:w-10/12 border-t-primary border-t-[15px] px-5 md:px-10 py-10 mx-5 mb-20">
    @if (!loading() && valid_credentials()) {
      <h1 class="text-center text-primary text-2xl font-bold font-comfortaa underline">Finalisation de votre inscription à TOTEiM</h1>

      <h2 class="text-xl font-semibold mt-12">Qu'est-ce que TOTEiM ?</h2>

      <p class="mt-4">TOTEiM est une fonctionnalité d'ImmoPad, permettant d'envoyer son état des lieux à votre locataire, vos occupants auront un espace locataire dédié. Vous avez également votre espace TOTEiM Gestionnaire pour piloter ce que peuvent demander vos locataires et suivre leurs demandes. Veuillez renseigner les informations ci-dessous pour le bon fonctionnement.</p>

      <form [formGroup]="formGroup" (ngSubmit)="sendData()" class="mt-8">
        <div class="flex flex-col mb-4">
          <label for="email" class="mb-2">
            <span translate="onboarding.contact-email"></span>
            <fa-icon class="text-muted-foreground ml-2" size="xl" [icon]="faIcons.faCircleInfo" pTooltip="Enter your username" tooltipPosition="right"></fa-icon>
          </label>
          <input id="email" type="email" class="md:ml-5 w-full md:w-8/12" placeholder="{{ 'onboarding.contact-email' | translate }}" formControlName="contact_email" pInputText required [class]="formGroup.get('contact_email')?.invalid && formGroup.get('contact_email')?.touched ? 'ng-invalid ng-dirty' : ''" />
          @if (formGroup.get("contact_email")?.errors?.["required"] && formGroup.get("contact_email")?.touched) {
            <t-input-error class="md:ml-5" translationKey="error.field-required" fieldTranslationKey="onboarding.contact-email"></t-input-error>
          }
          @else if (formGroup.get("contact_email")?.errors?.["email"] && formGroup.get("contact_email")?.touched) {
            <t-input-error class="md:ml-5" translationKey="error.email-not-valid"></t-input-error>
          }
        </div>

        <div class="flex flex-col gap-4 mt-8">
          <span translate="onboarding.acknowledgement"></span>

          <div class="flex items-center md:ml-5">
            <p-radiobutton [value]="true" formControlName="acknowledgement_receipt" inputId="acknowledgement-y" [class]="formGroup.get('acknowledgement_receipt')?.invalid && formGroup.get('acknowledgement_receipt')?.touched ? 'ng-invalid ng-dirty' : ''"></p-radiobutton>
            <label for="acknowledgement-y" class="ml-2" translate="onboarding.acknowledgement-y"></label>
          </div>

          <div class="flex items-center md:ml-5">
            <p-radiobutton [value]="false" formControlName="acknowledgement_receipt" inputId="acknowledgement-n" [class]="formGroup.get('acknowledgement_receipt')?.invalid && formGroup.get('acknowledgement_receipt')?.touched ? 'ng-invalid ng-dirty' : ''"></p-radiobutton>
            <label for="acknowledgement-n" class="ml-2" translate="onboarding.acknowledgement-n"></label>
          </div>

          @if (formGroup.get("acknowledgement_receipt")?.errors?.["required"] && formGroup.get("acknowledgement_receipt")?.touched) {
            <t-input-error class="md:ml-5" translationKey="error.field-required" fieldTranslationKey="onboarding.acknowledgement"></t-input-error>
          }
        </div>

        <div class="flex flex-row-reverse mt-10">
          <t-button label="onboarding.next" severity="contrast" styleClass="px-10" size="large" [loading]="btn_loading()" type="submit" />
        </div>
      </form>
    }
    @else if (!loading()) {
      <div class="flex flex-col items-center text-center w-full">
        <img [src]="'assets/img/' + theme() + '/error.svg'" class="ml-5 my-auto w-[200px] h-auto" draggable="false" alt="error" />
        <span class="font-semibold mt-5" [translate]="error_message()"></span>
      </div>
    }
    @else {
      <div class="flex flex-col items-center w-full">
        <p-progress-spinner ariaLabel="loading" />
        <span class="mt-5" translate="onboarding.loading"></span>
      </div>
    }
  </div>
</div>
